import React from "react";

import { CHART_EDIT_TAGS_TABLE_STRINGS } from "constants/constantStrings";

import PopoverText from "components/PopoverText";

import InfoIconGreen from "assets/Other/info-icon-green.svg";

const ChartTrendHeaderRenderer = props => (
  <div className="edit-chart-tags-table--header">
    {props.displayName}
    <PopoverText
      descriptor={<img src={InfoIconGreen} alt="icon" />}
      descriptionText={CHART_EDIT_TAGS_TABLE_STRINGS.headerTranlineDesc}
      customClass="trend-info__popover-width"
    />
  </div>
);

export default ChartTrendHeaderRenderer;
